/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
  Table,
  Checkbox,
  Input,
  Segment,
} from "semantic-ui-react";
import cogoToast from "cogo-toast";
import {
  withFormik,
  Form as Formiker,
  Field as Fieldmik,
  FieldArray,
} from "formik";
import ReadAxios from "../axiosComponent/read";
import { isEmpty, values } from "lodash";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import * as yup from "yup";
import { MyInput } from "../dynamicComponent/myInputs";
import { translate } from "react-i18next";
import { AllRegex } from "../../utils/validation";
import SearchDropdown from "../createShipmentComponent/searchDropdown";
import VehicleSearch from "../createShipmentComponent/vehicleSearch";
import SearchDropdownD from "../createShipmentComponent/searchDropdownD";
import VendorName from "./vendorName";
import Getreefertype from "./getrerfer-type";
import Gettypetype from "./gettrucktype";
import UpdateAxios from "../axiosComponent/update";
import MyDriver from "../dynamicComponent/myDriver";
import { DateData } from "../dynamicComponent/datepick";
import moment from "moment";
import MandatoryMark from "../common/mandatorymark";
import { LOCAL_STORAGE, FEATURES, DATE_FORMATS } from '../../utils/constant'
import { PROMPTS } from "../../utils/validationConstant";
import {aesDecrypt} from '../../utils/commonFunctionalities'

const ModalVehicleDetail = ({
  values,
  isSubmitting,
  role,
  handleSubmit,
  test,
  setFieldValue,
  vehicleNumber,
  vehicleType,
  touched,
  OpenModal,
  CloseModal,
  errors,
  order,
  t,
  allotment_status,
  auth,
  ...props
}) => {

  const [modalOpen, setmodalOpen] = useState(false);
  const [Driver, setDriver] = useState([]);
  const [Network, setNetwork] = useState([]);
  const [VehicleTypes, setVehicleTypes] = useState([]);
  const [TrackingTypes, setTrackingTypes] = useState([]);
  const [isEditing, setisEditing] = useState(false);
  const [VehicleFetched, setVehicleFetched] = useState([]);
  const [vehicleTypeText, setVehicleTypeText] = useState([]);
  const [ownership, setownership] = useState([]);
  const [vendorName, setvendorName] = useState("NA");
  const [warnings, setWarnings] = useState({ PUC: false, insurance: false, permit: false, road_tax: false, fitness: false, foodPermit: false, distributionPermit:false, securityClearancePermit:false })
  useEffect(() => {
    getAllFetch();
    if (order.vehicle_id) {
      getvehicleDetails(order.vehicle_id);
    }
  }, [order]);

  useEffect(() => {
    if(VehicleTypes.length > 0 && VehicleFetched.length > 0 && VehicleFetched[0].vehicleTypeMasterId){
      let vehicle_type = VehicleTypes.find((type)=> type.value === VehicleFetched[0].vehicleTypeMasterId)
      if(vehicle_type){
        setVehicleTypeText(vehicle_type.text)
      }
    }
  }, [VehicleTypes, VehicleFetched]);

  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    OpenModal = false;
  };
  let handleSubmited = () => {
    handleSubmit();
  };

  const setInitialDriverDetails = ()=>{
    let driver_name = getDriverName(order.driver_id)
    let driver_number = getDriverNumber(order.driver_id)
    let driver_lic = getDriverLicenseNumber(order.driver_id)
    let driver_lic_expiry = getDriverLicenseExpiryDate(order.driver_id)
    let network_provider_name = getDriverServiceProvider(order.driver_id)
    let network_provider_id
    if(network_provider_name){
      network_provider_id = getNetworkProvider(network_provider_name)
    }
    driver_name && setFieldValue("driver_name", driver_name);
    driver_number && setFieldValue("driver_number", driver_number);
    driver_lic && setFieldValue("driver_lic", driver_lic);
    driver_lic_expiry && (Date.parse(driver_lic_expiry)) && setFieldValue("driver_lic_expiry_date", new Date(driver_lic_expiry));
    network_provider_id && setFieldValue("network_provider",network_provider_id );
  }

  const getAllFetch = () => {
    ReadAxios({ url: `driverMaster`, readItems: { driverLeft: '0' } })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setDriver([])
          : setDriverState(res.data.resultSet);setVehicleTypes
      })
      .catch((err) => setDriver([]));
    ReadAxios({ url: "networkProviderMaster" })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setNetwork([])
          : setNetworkTypeState(res.data.resultSet);
      })
      .catch((err) => {
        setVehicleTypes([]);
      });
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleOwnershipType`,
    })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setOwnershipType([])
          : setOwnershipType(res.data.resultSet);
      })
      .catch((err) => {
        setVehicleTypes([]);
      });
    ReadAxios({ url: `vehicleTypeMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVehicleTypes([])
          : setVehicleTypeState(res.data.resultSet);
      })
      .catch((err) => {
        setVehicleTypes([]);
      });
    ReadAxios({ url: `trackingTypeMaster` })
      .then((res) => {
        if (isEmpty(res.data.resultSet)){
          setTrackingTypes([])
        }else{
          let result = order.service_type_id === 2 ? 
          res.data.resultSet : 
          res.data.resultSet.filter((trackingType)=> trackingType.trackingTypeId !== 5) //excluding PTL Tracking for FTL order

          setTrackingTypesState(result)
        }
      })
      .catch((err) => {
        setTrackingTypes([]);
      });
  };

  const setDriverState = (dataArray, ...args) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.driverNameContactNo,
        key: index,
        value: item.driverMasterId,
      };
    });
    setDriver(result);
  };

  const setOwnershipType = (dataArray) => {
    // if (order.ownership_type_name !== "Owned Vehicle") {
    //   let result = dataArray
    //     .find((ele) => {
    //       return ele.vehicleOwnershipTypeName == "Owned Vehicle";
    //     })
    //     .map((item, index) => {
    //       return {
    //         raw: { ...item },
    //         text: item.vehicleOwnershipTypeName,
    //         key: index,
    //         value: item.vehicleOwnershipTypeId,
    //       };
    //     });
    //   setownership(result);

    // let result = dataArray.map((item, index) => {
    //   return {
    //     raw: { ...item },
    //     text: item.vehicleOwnershipTypeName,
    //     key: index,
    //     value: item.vehicleOwnershipTypeId,
    //   };
    // });
    // } else {
    //   let result = dataArray.map((item, index) => {
    //     return {
    //       raw: { ...item },
    //       text: item.vehicleOwnershipTypeName,
    //       key: index,
    //       value: item.vehicleOwnershipTypeId,
    //     };
    //   });
    //   setownership(result);
    // }
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.vehicleOwnershipTypeName,
        key: index,
        value: item.vehicleOwnershipTypeId,
      };
    });
    setownership(result);
    //console.log("---------- Test vehicleonewershipType---------");
    //console.log({ result });
  };

  const setVehicleTypeState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.vehicleType + " " + "(" + item.vehicleTypeTonnage + ")",
        key: index,
        value: item.vehicleTypeId,
      };
    });
    setVehicleTypes(result);
  };

  const setNetworkTypeState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        key: index,
        text: item.networkProviderName,
        value: item.networkProviderMasterId,
        raw: { ...item },
      };
    });
    setNetwork(result);
  };

  const setTrackingTypesState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        key: index,
        text: item.trackingType,
        value: item.trackingTypeId,
        raw: { ...item },
      };
    });
    setTrackingTypes(result);
  };

  const getTrackingType = (id) => {
    let found = TrackingTypes.find((ele) => ele.value === id);
    if (found) {
      return found.text;
    }
    return "NA";
  };

  const getDriverName = (id) => {
    let found = Driver.find((ele) => ele.value === id);
    if (found) {
      return found.text;
    }
    return "NA";
  };

  const getDriverNumber = (id) => {
    let found = Driver.find((ele) => ele.value === id);
    if (found) {
      return found.raw.driverContact;
    }
    return "NA";
  };

  const getDriverLicenseNumber = (id) => {
    let found = Driver.find((ele) => ele.value === id);
    if (found?.raw?.driverLicense) {
      return aesDecrypt(found?.raw?.driverLicense);
    }
    return "NA";
  };

  const getDriverLicenseExpiryDate = (id) => {
    let found = Driver.find((ele) => ele.value === id);
    if (found && found.raw.driverLicenceExpiryDate) {
      return moment(found.raw.driverLicenceExpiryDate).format(DATE_FORMATS.DDMMYYYY)
    }
    return "NA";
  };

  const getDriverServiceProvider = (id) => {
    let found = Driver.find((ele) => ele.value === id);
    if (found) {
      return found.raw.serviceProvider;
    }
    return "NA";
  };

  const getNetworkProvider = (name) => {
    let found = Network.find((ele) => ele.text.toString().toUpperCase() === name.toString().toUpperCase());
    if (found) {
      return found.value;
    }
    return "NA";
  };

  const setDriverName = (name, value) => {
    console.log(value,'eeeeeeeeeeee');
    setFieldValue(
      "driver_id",
      value?.raw ? value.raw.driverMasterId : undefined
    );
    setFieldValue("driver_name", value.raw ? value.raw.driverName : value);
    setFieldValue("driver_number", value.raw ? value.raw.driverContact : "");
    setFieldValue("driver_lic", value?.raw?.driverLicense ? aesDecrypt(value.raw.driverLicense) : "");
    if (value?.raw?.driverLicenceExpiryDate && value?.raw?.driverLicenceExpiryDate instanceof Date && !isNaN(value?.raw?.driverLicenceExpiryDate)) {
      setFieldValue("driver_lic_expiry_date", value.raw && value.raw.driverLicenceExpiryDate && (Date.parse(value.raw.driverLicenceExpiryDate)) ? new Date(value.raw.driverLicenceExpiryDate) : "");
    }
    setFieldValue(
      "network_provider",
      value.raw ? value.raw.serviceProviderId : null
    );
  };

  const handleWarnings = (warningName, value) => {
    let budgeted_time_string = props?.shipmentDetails?.budgeted_time.split(" ")
    let budgeted_time = Number(budgeted_time_string[0])
    let currentTime = new Date().getTime();
    let updatedDate
    if (budgeted_time) {
      updatedDate = new Date(currentTime + budgeted_time * 60 * 60 * 1000);
    }
    if (updatedDate) {
      let warningObj = warnings
      value ? (new Date(value) <= updatedDate ? warningObj[warningName] = true : warningObj[warningName] = false) : warningObj[warningName] = false
      setWarnings(warningObj)
    }
  }

  const getvehicleDetails = (id) => {
    ReadAxios({ url: `vehicleMaster/${id}` })
      .then((res) => {
        if (res.data.resultSet?.length > 0) {
          setVehicleFetched(res.data.resultSet);
          setFieldValue("vehicle_type", res.data.resultSet[0]?.vehicleTypeMasterId ? res.data.resultSet[0]?.vehicleTypeMasterId : "");
          setVehicleDocumentDates(res.data.resultSet[0])
        }
      })
      .catch((err) => {
        setVehicleFetched([]);
      });
  };

  const setVehicleDocumentDates = (result)=>{
          let budgeted_time_string = props?.shipmentDetails?.budgeted_time.split(" ")
          let budgeted_time = Number(budgeted_time_string[0])
          let currentTime = new Date().getTime();
          let updatedDate
          if (budgeted_time) {
            updatedDate = new Date(currentTime + budgeted_time * 60 * 60 * 1000);
          }
          let values = { reg: null, PUC: null, insurance: null, road_tax: null, permit: null, fitness: null, foodPermit:null, distributionPermit:null, securityClearancePermit:null }
          values.reg = result?.regDate && moment(result.regDate, DATE_FORMATS.DATE_DDMMYYYY,true).isValid() ? new Date(moment(result.regDate, DATE_FORMATS.DATE_DDMMYYYY)) : updatedDate
          values.PUC = result?.vehiclePUCExpiryDate && moment(result.vehiclePUCExpiryDate, DATE_FORMATS.YYYYMMDDHHmmss,true).isValid() ? new Date(result.vehiclePUCExpiryDate) : updatedDate
          values.road_tax = result?.vehicleRoadTaxValidityDate && moment(result.vehicleRoadTaxValidityDate, DATE_FORMATS.YYYYMMDDHHmmss,true).isValid() ? new Date(result.vehicleRoadTaxValidityDate) : updatedDate
          values.permit = result?.vehiclePermitExpiryDate && moment(result.vehiclePermitExpiryDate, DATE_FORMATS.YYYYMMDDHHmmss,true).isValid() ? new Date(result.vehiclePermitExpiryDate) : updatedDate
          values.insurance = result?.vehicleInsuranceExpiryDate && moment(result.vehicleInsuranceExpiryDate, DATE_FORMATS.YYYYMMDDHHmmss,true).isValid() ? new Date(result.vehicleInsuranceExpiryDate) : updatedDate
          values.fitness = result?.vehicleFitnessCertExpiryDate && moment(result.vehicleFitnessCertExpiryDate, DATE_FORMATS.YYYYMMDDHHmmss,true).isValid() ? new Date(result.vehicleFitnessCertExpiryDate) : updatedDate


          setFieldValue("vehicle_registration_date", values.reg)

          setFieldValue("PUC_expiry_date", values.PUC)
          handleWarnings("PUC", values.PUC)

          setFieldValue("road_tax_expiry_date", values.road_tax)
          handleWarnings("road_tax", values.road_tax)

          setFieldValue("permit_expiry_date", values.permit)
          handleWarnings("permit", values.permit)

          setFieldValue("insurance_expiry_date", values.insurance)
          handleWarnings("insurance", values.insurance)

          setFieldValue("fitness_expiry_date", values.fitness)
          handleWarnings("fitness", values.fitness)
  }

  const setVehicleNumber = (name, value) => {
    setFieldValue(
      "vehicle_number",
      value.raw ? value.raw.vehicleNumber : value
    );
    setFieldValue("vehicle_type", value.raw ? value.raw.vehicleTypeId : "");
    setFieldValue(
      "ownership_type",
      value.raw ? (value.raw.vehicleOwner == "Market" ? 2 : 1) : ""
    );
    if(value?.raw?.vehicleId){
      getvehicleDetails(value.raw.vehicleId)
    }else{
      if(value && AllRegex.VehicleNumber.test(value)){
        setVehicleDocumentDates({})
      }
    }
  };

  return (
    <div>
      <Modal
        open={OpenModal}
        onClose={CloseModal}
        size="fullscreen"
      // trigger={
      //   <Button
      //     type="button"
      //     onClick={handleOpen}
      //     size="mini"
      //     basic
      //     color="blue"
      //     className="w3-blue w3-round w3-hover-blue"
      //   >
      //     {t("title") || "Vehicle Detail"}
      //   </Button>
      // }
      >
        <Modal.Header className="p-bold-100">
          <span>{t("title") || "Vehicle Details"}</span>
          { order.undo_vendor_possible &&
            !isEditing ? (
            <>
              <Button
                type="button"
                disabled={role == "Quality Control" ? true : false}
                onClick={() => {
                  setisEditing(true)
                  order.driver_id && setInitialDriverDetails()
                }}
                size="mini"
                basic
                icon
                className="w3-blue w3-round w3-hover-blue"
                style={{ position: "absolute", right: "30px" }}
              >
                <Icon name="pencil alternate" />{" "}
                {t("action_button.edit") || "Edit"}
              </Button>
            </>
          ) : (
            <>
              {allotment_status &&
                allotment_status.allotment_code == "ACK" &&
                !isEditing ? (
                <Button
                  type="button"
                  disabled={role == "Quality Control" ? true : false}
                  onClick={() => setisEditing(true)}
                  size="mini"
                  basic
                  icon
                  className="w3-blue w3-round w3-hover-blue"
                  style={{ position: "absolute", right: "30px" }}
                >
                  <Icon name="pencil alternate" />{" "}
                  {t("action_button.edit") || "Edit"}
                </Button>
              ) : null}
            </>
          )}
          {isEditing && (
            <Button
              type="button"
              onClick={() => setisEditing(false)}
              size="mini"
              basic
              icon
              className="w3-blue w3-round w3-hover-blue"
              style={{ position: "absolute", right: "30px" }}
            >
              <Icon name="times" /> {t("action_button.cancel") || "Cancel"}
            </Button>
          )}
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {isEditing ? (
              <div className="ui tiny form">
                <Formiker>
                  <Segment className="padding-0-imp">
                    <div className="ui form tiny p-bold-600">
                      {/* <FormUi.Group
                        inline
                        className="vehicle-detail-heading-wrapper padding-15px_lr"
                      >
                        <FormUi.Field>
                          <h3 className="vehicle-detail-heading padding-left-0">
                            Vendor LR Details
                          </h3>
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr" inline>
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vendor_name") || "Vendor"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={3}
                          className="vehicle-detail-wrapper"
                        >
                          <Fieldmik
                            name="vendor"
                            component={MyInput}
                            readOnly={true ? true : false}
                            error={
                              touched.vendor && errors.vendor ? true : false
                            }
                            value={vendorName}
                          />
                          {touched.vendor && errors.vendor ? (
                            <div>{errors.vendor}</div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vendor_lr_number") ||
                              "Vendor LR No"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={3}
                          className="vehicle-detail-wrapper"
                        >
                          <Fieldmik
                            name="vendor_lr_number"
                            component={MyInput}
                            error={
                              touched.vendor_lr_number &&
                                errors.vendor_lr_number
                                ? true
                                : false
                            }
                          />
                          {touched.vendor_lr_number &&
                            errors.vendor_lr_number ? (
                            <div>{errors.vendor_lr_number}</div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr" inline>
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vendor_lr_date") ||
                              "Vendor LR Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={3}
                          className="vehicle-detail-wrapper"
                        >
                          <Fieldmik
                            name="vendor_lr_date"
                            component={MyInput}
                            error={
                              touched.vendor_lr_date && errors.vendor_lr_date
                                ? true
                                : false
                            }
                          />
                          {touched.vendor_lr_date && errors.vendor_lr_date ? (
                            <div>{errors.vendor_lr_date}</div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1}></FormUi.Field>
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vendor_branch") ||
                              "Partner Branch"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <Dropdown
                            name="vendor_branch"
                            clearable
                            search
                            style={{ width: "100%" }}
                            selection
                            onChange={(name, data) => {
                              console.log(data);
                              setFieldValue("vendor_branch", data.value);
                            }}
                            options={[
                              { key: "2", text: "Delhi", value: "delhi" },
                              { key: "3", text: "Mumbai", value: "mumbai" },
                              { key: "1", text: "Bangalore", value: "bangalore" },
                            ]}
                            disabled={!isEditing ? true : false}
                            error={
                              touched.vendor_branch && errors.vendor_branch
                                ? true
                                : false
                            }
                            value={values.vendor_branch}
                          />
                          {touched.vendor_branch && errors.vendor_branch ? (
                            <div>
                              {t(
                                `vehicle_type.vendor_branch.${errors.vendor_branch}`
                              ) || errors.vendor_branch}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>

                       */}
                      <FormUi.Group
                        className="vehicle-detail-heading-wrapper padding-15px_lr"
                      >
                        <FormUi.Field>
                          <h3 className="vehicle-detail-heading padding-left-0">
                            Vehicle Details
                          </h3>
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vehicle_type") || "Vehicle Type"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3} className="display-grid-center-imp">
                          <Dropdown
                            name="vehicle_type"
                            clearable
                            search
                            style={{ width: "100%" }}
                            selection
                            placeholder={"Select Vehicle"}
                            onChange={(name, data) => {
                              console.log(data);
                              setFieldValue("vehicle_type", data.value);
                            }}
                            options={VehicleTypes}
                            disabled={!isEditing ? true : false}
                            error={
                              touched.vehicle_type && errors.vehicle_type
                                ? true
                                : false
                            }
                            value={values.vehicle_type}
                          />
                          {touched.vehicle_type && errors.vehicle_type ? (
                            <p className="error-msg">
                              {t(`vehicle_type.error_msg.${errors.vehicle_type}`) || errors.vehicle_type}
                            </p>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vehicle_number") ||
                              "Vehicle Number"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3} className="display-grid-center-imp">
                          <VehicleSearch
                            setField={setVehicleNumber}
                            masterRoute={
                              "vendorMaster/vehicles/" + order.vendor_id
                            }
                            masterRouteKey="vehicleId"
                            masterRouteName="vehicleNumber"
                            fieldName="vehicle_number"
                            placeholder={vehicleNumber}
                          />
                          {touched.vehicle_number && errors.vehicle_number ? (
                            <p className="error-msg">
                              {t(`vehicle_number.error_msg.${errors.vehicle_number}`) || errors.vehicle_number}
                            </p>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr" >
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.ownership_type") ||
                              "Ownership Type"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3} className="display-grid-center-imp">
                          <Dropdown
                            name="ownership_type"
                            clearable
                            search
                            style={{ width: "100%" }}
                            selection
                            placeholder={"Ownership Type"}
                            onChange={(name, data) => {
                              console.log(data);
                              setFieldValue("ownership_type", data.value); // +data.value
                            }}
                            options={
                              order.ownership_type_name === "Owned Vehicle"
                                ? ownership.filter(
                                  (el) =>
                                    el.text === order.ownership_type_name
                                )
                                : ownership
                            }
                            /* disabled={
                              values.ownership_type
                                ? true
                                : !isEditing
                                  ? true
                                  : false
                            } */
                            disabled={!isEditing ? true : false}
                            error={
                              touched.vehicle_type && errors.vehicle_type
                                ? true
                                : false
                            }
                            value={values.ownership_type}
                          />
                          {touched.vehicle_type && errors.vehicle_type ? (
                            <p className="error-msg">
                              {t(`vehicle_type.error_msg.${errors.vehicle_type}`) || errors.vehicle_type}
                            </p>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.truck_type") || "Truck Type"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <Dropdown
                            name="truck_type"
                            clearable
                            search
                            style={{ width: "100%" }}
                            selection
                            placeholder={
                              t("reefer_type_and_model.placeholder") ||
                              "Network Provider"
                            }
                            onChange={(name, data) => {
                              setFieldValue("truck_type", data.value);
                            }}
                            options={[
                              { key: "1", text: "Dry Container", value: "1" },
                              {
                                key: "2",
                                text: "Reefer Container",
                                value: "2",
                              },
                              { key: "3", text: "Open Body", value: "3" },
                            ]}
                            value={values.truck_type}
                            disabled={!isEditing ? true : false}
                          // error={
                          //   touched.truck_type && errors.truck_type
                          //     ? true
                          //     : false
                          // }
                          />
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr" >
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.gps_available") || "GPS Available"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <Checkbox
                            onChange={(e) =>
                              setFieldValue(
                                "gps_available",
                                e.target.checked ? 1 : 0
                              )
                            }
                            id="ga"
                            type="checkbox"
                            className="form-check-input large"
                          />
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.tracking_type") || "Tracking Type"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3} className="display-grid-center-imp">
                          <Dropdown
                            name="tracking_type"
                            clearable
                            search
                            style={{ width: "100%" }}
                            selection
                            placeholder={
                              t("tracking_type.placeholder") ||
                              "Select Tracking Type"
                            }
                            onChange={(name, data) => {
                              setFieldValue("tracking_type", data.value);
                            }}
                            options={TrackingTypes}
                            disabled={!isEditing ? true : (values.service_type === 2 ? true : false)}
                            error={
                              touched.tracking_type && errors.tracking_type
                                ? true
                                : false
                            }
                            defaultValue={values.tracking_type}
                          />
                          {touched.tracking_type && errors.tracking_type ? (
                            <div className="error-msg">
                              {t(
                                `tracking_type.error_msg.${errors.tracking_type}`
                              ) || errors.tracking_type}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group className="padding-15px_lr" >
                        <FormUi.Field width={3}>
                          <label>
                            {t("vehicle_seal_number.title") || "Vehicle Seal Number"}{" "}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3} className="vehicle-detail-wrapper padding-0-imp-child display-grid-center-imp">
                          <Fieldmik
                            name="vehicle_seal_no"
                            component={MyInput}
                            maxLength={50}
                            type="text"
                            readOnly={!isEditing ? true : false}
                            value={values.vehicle_seal_no}
                            error={
                              touched.vehicle_seal_no && errors.vehicle_seal_no
                                ? true
                                : false
                            }
                          />
                          {touched.vehicle_seal_no && errors.vehicle_seal_no ? (
                            <>
                              <br />
                              <p className="error-msg">
                                {t(`vehicle_seal_number.error_msg.${errors.vehicle_seal_no}`) || errors.vehicle_seal_no}
                              </p>
                            </>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />

                        {FEATURES.showUpdateEwayBill_VehicleAllocation &&
                          <>
                            <FormUi.Field width={3}>
                              <label>
                                {t("table_header.update_ewaybill") || "Update Eway-bill"}
                              </label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Checkbox
                                onChange={(e) =>
                                  setFieldValue(
                                    "ewaybill_part_b",
                                    e.target.checked ? true : false
                                  )
                                }
                                id="ew"
                                type="checkbox"
                                checked={values.ewaybill_part_b}
                                className="form-check-input large"
                              />
                            </FormUi.Field>
                          </>}

                      </FormUi.Group>
                      <FormUi.Group
                        className="vehicle-detail-heading-wrapper padding-15px_lr" >
                        <FormUi.Field>
                          <h3 className="vehicle-detail-heading padding-left-0">
                            Vehicle Documents
                          </h3>
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vehicle_registration_date") ||
                              "Vehicle Registration Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <DateData
                            name="vehicle_registration_date"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS?.ddMMyyyy}
                            customInput={
                              <Input
                                icon="time"
                                className="poupDate"
                                iconPosition="left"
                              />
                            }
                          />
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        {FEATURES.uaeVehicleCustomer ? 
                        <>
                        
                        </>

                        :<>
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.PUC_expiry_date") ||
                              "PUC Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <DateData
                            name="PUC_expiry_date"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS?.ddMMyyyy}
                            onChangeExtra={(val) => handleWarnings("PUC", val)}
                            customInput={
                              <Input
                                icon="time"
                                className="poupDate"
                                iconPosition="left"
                              />
                            }
                          />
                          {warnings.PUC &&
                            <div className="mt-1 mb-1">
                              <small class="alert-warning pt-2 pb-2 pr-2 w3-tiny">
                                {PROMPTS.DOCUMENTS_ABOUT_TO_EXPIRE}
                              </small>
                            </div>}
                        </FormUi.Field>
                        </>}
                      </FormUi.Group>

                      {FEATURES.uaeVehicleCustomer ? 

                      <>

                      </>

                      :<>
                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.insurance_expiry_date") ||
                              "Insurance Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <DateData
                            name="insurance_expiry_date"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS?.ddMMyyyy}
                            onChangeExtra={(val) => handleWarnings("insurance", val)}
                            customInput={
                              <Input
                                icon="time"
                                className="poupDate"
                                iconPosition="left"
                              />
                            }
                          />
                          {warnings.insurance &&
                            <div className="mt-1 mb-1">
                              <small class="alert-warning pt-2 pb-2 pr-2 w3-tiny">
                                {PROMPTS.DOCUMENTS_ABOUT_TO_EXPIRE}
                              </small>
                            </div>}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.permit_expiry_date") ||
                              "Permit Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <DateData
                            name="permit_expiry_date"
                            autoComplete="off"
                            popperClassName="dateTime"
                            onChangeExtra={(val) => handleWarnings("permit", val)}
                            dateFormat={DATE_FORMATS?.ddMMyyyy}
                            customInput={
                              <Input
                                icon="time"
                                className="poupDate"
                                iconPosition="left"
                              />
                            }
                          />
                          {warnings.permit &&
                            <div className="mt-1 mb-1">
                              <small class="alert-warning pt-2 pb-2 pr-2 w3-tiny">
                                {PROMPTS.DOCUMENTS_ABOUT_TO_EXPIRE}
                              </small>
                            </div>}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.road_tax_expiry_date") ||
                              "Road Tax Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <DateData
                            name="road_tax_expiry_date"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS?.ddMMyyyy}
                            onChangeExtra={(val) => handleWarnings("road_tax", val)}
                            customInput={
                              <Input
                                icon="time"
                                className="poupDate"
                                iconPosition="left"
                              />
                            }
                          />
                          {warnings.road_tax &&
                            <div className="mt-1 mb-1">
                              <small class="alert-warning pt-2 pb-2 pr-2 w3-tiny">
                                {PROMPTS.DOCUMENTS_ABOUT_TO_EXPIRE}
                              </small>
                            </div>}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.fitness_expiry_date") ||
                              "Fitness Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <DateData
                            name="fitness_expiry_date"
                            autoComplete="off"
                            popperClassName="dateTime"
                            onChangeExtra={(val) => handleWarnings("fitness", val)}
                            dateFormat={DATE_FORMATS?.ddMMyyyy}
                            customInput={
                              <Input
                                icon="time"
                                className="poupDate"
                                iconPosition="left"
                              />
                            }
                          />
                          {warnings.fitness &&
                            <div className="mt-1 mb-1">
                              <small class="alert-warning pt-2 pb-2 pr-2 w3-tiny">
                                {PROMPTS.DOCUMENTS_ABOUT_TO_EXPIRE}
                              </small>
                            </div>}
                        </FormUi.Field>
                      </FormUi.Group>
                      </>}

                      <FormUi.Group
                        className="vehicle-detail-heading-wrapper padding-15px_lr">
                        <FormUi.Field>
                          <h3 className="vehicle-detail-heading padding-left-0">
                            Driver Details
                          </h3>
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.number_of_driver") ||
                              "No Of Drivers"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <Dropdown
                            name="number_of_drivers"
                            clearable
                            search={false}
                            style={{ width: "100%" }}
                            selection
                            onChange={(name, data) => {
                              setFieldValue("number_of_drivers", data.value);
                            }}
                            defaultValue={"1"}
                            options={[
                              { key: "2", text: "1", value: "1" },
                              { key: "3", text: "2", value: "2" },
                              { key: "4", text: "3", value: "3" },
                            ]}
                            disabled={!isEditing ? true : false}
                          />
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3} className="display-grid-center-imp">
                          <label>
                            {t("table_header.driver_name") || "Driver Name"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <SearchDropdownD
                            name="driver_name"
                            placeholder={values.driver_name || ""}
                            setField={setDriverName}
                            masterRoute={`driverMaster`}
                            masterRouteKey="driverMasterId"
                            masterRouteName="driverNameContactNo"
                            fieldName="driver_id"
                            vendorid={order.vendor_id}
                            updateNullValue={true}
                          />
                          {touched.driver_name && errors.driver_name ? (
                            <>

                              <div className="error-msg">
                                {t(`driver_name.error_msg.${errors.driver_name}`) || errors.driver_name}
                              </div>
                            </>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.driver_number") || "Driver Number"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3} className="vehicle-detail-wrapper padding-0-imp-child display-grid-center-imp">
                          <Fieldmik
                            name="driver_number"
                            component={MyInput}
                            type="number"
                            readOnly={!isEditing ? true : false}
                            value={values.driver_number}
                            error={
                              touched.driver_number && errors.driver_number
                                ? true
                                : false
                            }
                          />
                          {touched.driver_number && errors.driver_number ? (
                            <>
                              <br />
                              <p className="error-msg">
                                {t(`driver_number.error_msg.${errors.driver_number}`) || errors.driver_number}
                              </p>
                            </>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.license_number") ||
                              "Driver License Number"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={3}
                          className="vehicle-detail-wrapper padding-0-imp-child display-grid-center-imp">
                          <Fieldmik
                            name="driver_lic"
                            component={MyInput}
                            placeholder={t(`driver_lic.placeholder`) || "Driver Licence Number"}
                            readOnly={!isEditing ? true : false}
                            value={values.driver_lic}
                            error={
                              touched.driver_lic && errors.driver_lic
                                ? true
                                : false
                            }
                          />
                          {touched.driver_lic && errors.driver_lic ? (

                            <p className="error-msg">
                              {t(`driver_lic.error_msg.${errors.driver_lic}`) || errors.driver_lic}
                            </p>

                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.network_provider") ||
                              "Network Provider"}
                          </label>
                          {values?.tracking_type &&
                            values.tracking_type == 2 ? (
                            <MandatoryMark />
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={3} className="display-grid-center-imp">
                          <Dropdown
                            name="network_provider"
                            upward={true}
                            clearable
                            search
                            style={{ width: "100%" }}
                            selection
                            scrolling={true}
                            placeholder={"Network Provider"}
                            onChange={(name, data) => {
                              setFieldValue("network_provider", data.value);
                            }}
                            options={Network}
                            value={values.network_provider}
                            disabled={!isEditing ? true : false}
                            error={
                              touched.network_provider &&
                                errors.network_provider
                                ? true
                                : false
                            }
                          />
                          {touched.network_provider &&
                            errors.network_provider ? (
                            // <p className="error-msg">
                            //   {t(`driver_lic.error_msg.${errors.driver_lic}`) || errors.driver_lic}
                            // </p>
                            <p className="error-msg">
                              {t(errors.network_provider)}
                            </p>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />

                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.driver_lic_expiry_date") ||
                              "Driver License Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3} className="display-grid-center-imp">
                          <DateData
                            name="driver_lic_expiry_date"
                            value={values.driver_lic_expiry_date}
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS?.ddMMyyyy}
                            customInput={
                              <Input
                                icon="time"
                                className="poupDate"
                                iconPosition="left"
                              />
                            }
                          />

                          {touched.driver_lic_expiry_date &&
                            errors.driver_lic_expiry_date ? (
                            <div>
                              <br />
                              <p className="error-msg">
                                {t(`driver_name.error_msg.${errors.driver_lic_expiry_date}`) || errors.driver_lic_expiry_date}
                              </p>
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>

                      {order.load_type_id != 4 ? (
                        <>
                          <FormUi.Group
                            className="vehicle-detail-heading-wrapper padding-15px_lr">
                            <FormUi.Field>
                              <h3 className="vehicle-detail-heading padding-left-0 ">
                                Cold Chain Details
                              </h3>
                            </FormUi.Field>
                          </FormUi.Group>

                          <FormUi.Group className="padding-15px_lr">
                            <FormUi.Field width={3}>
                              <label>
                                {t("table_header.data_logger_available") ||
                                  "Data Logger Available"}
                              </label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Checkbox
                                onChange={(e) => {
                                  setFieldValue(
                                    "data_logger_available",
                                    e.target.checked ? 1 : 0
                                  )
                                }
                                }
                                id="dla"
                                type="checkbox"
                                className="form-check-input large ml-3"
                              />
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            {values.data_logger_available == 1 &&
                              <>
                                <FormUi.Field width={3}>
                                  <label>
                                    {t("table_header.data_logger_number") ||
                                      "Data Logger No."}
                                  </label>
                                </FormUi.Field>

                                <FormUi.Field width={3} className="vehicle-detail-wrapper padding-0-imp-child display-grid-center-imp">
                                  <Fieldmik
                                    name="data_logger_no"
                                    component={MyInput}
                                    type="text"
                                    readOnly={!isEditing ? true : false}
                                    value={values.data_logger_no}
                                    error={
                                      touched.data_logger_no && errors.data_logger_no
                                        ? true
                                        : false
                                    }
                                  />
                                  {touched.data_logger_no && errors.data_logger_no ? (
                                    <>
                                      <br />
                                      <p className="error-msg">
                                        {t(`Data logger No ${errors.data_logger_no}`) || errors.data_logger_no}
                                      </p>
                                    </>
                                  ) : null}
                                </FormUi.Field>
                              </>}
                          </FormUi.Group>
                          <FormUi.Group className="padding-15px_lr">
                            {/* 
                            <FormUi.Field width={3}>
                              <label>
                                {t(
                                  "table_header.data_logger_recalibration_date"
                                ) || "Data Logger Recalibration Date"}
                              </label>
                            </FormUi.Field>
                            <FormUi.Field width={3}></FormUi.Field>
                            <FormUi.Field width={1} /> */}
                            <FormUi.Field width={3}>
                              <label>
                                {t("table_header.red_line_inside_container") ||
                                  "Red-Line inside Container"}
                              </label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Checkbox
                                onChange={(e) =>
                                  setFieldValue(
                                    "red_line_inside_container",
                                    e.target.checked ? 1 : 0
                                  )
                                }
                                id="rlic"
                                type="checkbox"
                                className="form-check-input large ml-3"
                              />
                            </FormUi.Field>
                          </FormUi.Group>
                        </>
                      ) : null}
                    </div>
                  </Segment>
                </Formiker>
              </div>
            ) : (
              <div className="ui tiny table">
                <Formiker>
                  <Segment className="padding-0-imp">
                    <div className="ui form tiny p-bold-600">
                      {/* <FormUi.Group
                        inline
                        className="vehicle-detail-heading-wrapper padding-15px_lr"
                      >
                        <FormUi.Field>
                          <h3 className="vehicle-detail-heading padding-left-0">
                            Vendor LR Details
                          </h3>
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr" inline>
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vendor_name") || "Partner"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <VendorName
                            vendorID={order.vendor_id}
                            vendorNameCallback={setvendorName}
                          />
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vendor_lr_number") ||
                              "Partner LR No"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {order?.deliveries[0]?.lr_no ? (
                            <>{order.deliveries[0].lr_no}</>
                          ) : (
                            <>NA</>
                          )}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr" inline>
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vendor_lr_date") ||
                              "Partner LR Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {order?.deliveries[0]?.lr_date ? (
                            <>{order.deliveries[0].lr_date}</>
                          ) : (
                            <>NA</>
                          )}
                        </FormUi.Field>
                        <FormUi.Field width={1}></FormUi.Field>
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vendor_branch") ||
                              "Partner Branch"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>NA</FormUi.Field>
                      </FormUi.Group>

                       */}
                      <FormUi.Group
                        className="vehicle-detail-heading-wrapper padding-15px_lr">
                        <FormUi.Field>
                          <h3 className="vehicle-detail-heading padding-left-0">
                            Vehicle Details
                          </h3>
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vehicle_type") || "Vehicle Type"}
                          </label>
                        </FormUi.Field>
                        {console.log("vehicleType", VehicleFetched)}
                        <FormUi.Field width={3}>
                          {vehicleTypeText
                            ? vehicleTypeText
                            : "NA"}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vehicle_number") ||
                              "Vehicle Number"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {VehicleFetched.length > 0
                            ? VehicleFetched[0].vehicleNumber
                            : "NA"}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.ownership_type") ||
                              "Ownership Type"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {order.ownership_type_name && order.vehicle_id ? (
                            <>{order.ownership_type_name}</>
                          ) : (
                            "NA"
                          )}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.truck_type") || "Truck Type"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {order.truck_type ? (
                            <Gettypetype id={order.truck_type} />
                          ) : (
                            "NA"
                          )}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.gps_available") || "GPS Available"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {order.gps_available == true ? "YES" : "NO"}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.tracking_type") || "Tracking Type"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {getTrackingType(order.tracking_type) || "NA"}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("vehicle_seal_number.title") || "Vehicle Seal No"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {order?.vehicle_seal_no ? order.vehicle_seal_no : "NA"}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        {FEATURES.showUpdateEwayBill_VehicleAllocation &&
                          <>
                            <FormUi.Field width={3}>
                              <label>
                                {t("table_header.update_ewaybill") || "Update Eway-bill"}
                              </label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              {order?.ewaybill_part_b == true ? "YES" : "NO"}
                            </FormUi.Field>
                          </>}
                        {/* <FormUi.Field width={3}> */}
                        {/* <label>
                            {t("table_header.tracking_type") || "Tracking Type"}
                          </label> */}
                        {/* </FormUi.Field>
                        <FormUi.Field width={3}> */}
                        {/* {getTrackingType(order.tracking_type) || "NA"} */}
                        {/* </FormUi.Field> */}
                      </FormUi.Group>
                      <FormUi.Group
                        className="vehicle-detail-heading-wrapper padding-15px_lr">
                        <FormUi.Field>
                          <h3 className="vehicle-detail-heading padding-left-0">
                            Vehicle Documents
                          </h3>
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.vehicle_registration_date") ||
                              "Vehicle Registration Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {VehicleFetched.length > 0 && VehicleFetched[0].regDate ?
                            moment(VehicleFetched[0].regDate, DATE_FORMATS.DDMMYYYY).format(DATE_FORMATS.DDMMYYYY)
                            : "NA"}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        {FEATURES.uaeVehicleCustomer ? 
                        <>
                        
                        </>
                        :<>
                          <FormUi.Field width={3}>
                          <label>
                            {t("table_header.PUC_expiry_date") ||
                              "PUC Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {VehicleFetched.length > 0 && VehicleFetched[0].vehiclePUCExpiryDate ?
                            moment(VehicleFetched[0].vehiclePUCExpiryDate).format(DATE_FORMATS.DDMMYYYY)
                            : "NA"}
                        </FormUi.Field>
                        </>}
                      </FormUi.Group>

                      {FEATURES.uaeVehicleCustomer ? 
                        <>
                        
                        </>

                        :<>
                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.insurance_expiry_date") ||
                              "Insurance Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {VehicleFetched.length > 0 && VehicleFetched[0].vehicleInsuranceExpiryDate ?
                            moment(VehicleFetched[0].vehicleInsuranceExpiryDate).format(DATE_FORMATS.DDMMYYYY)
                            : "NA"}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.permit_expiry_date") ||
                              "Permit Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {VehicleFetched.length > 0 && VehicleFetched[0].vehiclePermitExpiryDate ?
                            moment(VehicleFetched[0].vehiclePermitExpiryDate).format(DATE_FORMATS.DDMMYYYY)
                            : "NA"}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.road_tax_expiry_date") ||
                              "Road Tax Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {VehicleFetched.length > 0 && VehicleFetched[0].vehicleRoadTaxValidityDate ?
                            moment(VehicleFetched[0].vehicleRoadTaxValidityDate).format(DATE_FORMATS.DDMMYYYY)
                            : "NA"}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.fitness_expiry_date") ||
                              "Fitness Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {VehicleFetched.length > 0 && VehicleFetched[0].vehicleFitnessCertExpiryDate ?
                            moment(VehicleFetched[0].vehicleFitnessCertExpiryDate).format(DATE_FORMATS.DDMMYYYY)
                            : "NA"}
                        </FormUi.Field>
                        
                      </FormUi.Group>
                      </>}

                      <FormUi.Group
                        className="vehicle-detail-heading-wrapper padding-15px_lr">
                        <FormUi.Field>
                          <h3 className="vehicle-detail-heading padding-left-0">
                            Driver Details
                          </h3>
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.number_of_driver") ||
                              "No Of Drivers"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {order.number_of_drivers &&
                            order.number_of_drivers ? (
                            <>{order.number_of_drivers}</>
                          ) : (
                            "NA"
                          )}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.driver_name") || "Driver Name"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {getDriverName(order.driver_id) || "NA"}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr" >
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.driver_number") || "Driver Number"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {getDriverNumber(order.driver_id) || "NA"}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.license_number") ||
                              "Driver License Number"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {getDriverLicenseNumber(order.driver_id) || "NA"}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group className="padding-15px_lr">
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.network_provider") ||
                              "Network Provider"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {getDriverServiceProvider(order.driver_id) || "NA"}
                        </FormUi.Field>
                        <FormUi.Field width={1} />
                        <FormUi.Field width={3}>
                          <label>
                            {t("table_header.driver_lic_expiry_date") ||
                              "Driver License Expiry Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          {getDriverLicenseExpiryDate(order.driver_id) || "NA"}
                        </FormUi.Field>
                      </FormUi.Group>

                      {order.load_type_id != 4 ? (
                        <>
                          <FormUi.Group
                            className="vehicle-detail-heading-wrapper padding-15px_lr"
                          >
                            <FormUi.Field>
                              <h3 className="vehicle-detail-heading padding-left-0">
                                Cold Chain Details
                              </h3>
                            </FormUi.Field>
                          </FormUi.Group>

                          <FormUi.Group className="padding-15px_lr" >
                            <FormUi.Field width={3}>
                              <label>
                                {t("table_header.data_logger_available") ||
                                  "Data Logger Available"}
                              </label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              {order.data_logger_available == true
                                ? "YES"
                                : "NO"}
                            </FormUi.Field>

                            {order.data_logger_available == true &&
                              <>
                                <FormUi.Field width={3}>
                                  <label>
                                    {t("table_header.data_logger_number") ||
                                      "Data Logger No."}
                                  </label>
                                </FormUi.Field>
                                <FormUi.Field width={3} className="vehicle-detail-wrapper padding-0-imp-child display-grid-center-imp">
                                  <Fieldmik
                                    name="data_logger_no"
                                    component={MyInput}
                                    type="text"
                                    readOnly={!isEditing ? true : false}
                                    value={order.data_logger_no}
                                    error={
                                      touched.data_logger_no && errors.data_logger_no
                                        ? true
                                        : false
                                    }
                                  />
                                </FormUi.Field>
                              </>
                            }
                          </FormUi.Group>

                          <FormUi.Group className="padding-15px_lr">
                            {/* <FormUi.Field width={3}>
                              <label>
                                {t(
                                  "table_header.data_logger_recalibration_date"
                                ) || "Data Logger Recalibration Date"}
                              </label>
                            </FormUi.Field>
                            <FormUi.Field width={3}></FormUi.Field> */}

                            <FormUi.Field width={3}>
                              <label>
                                {t("table_header.red_line_inside_container") ||
                                  "Red-Line inside Container"}
                              </label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              {order.red_line_inside_container == true
                                ? "YES"
                                : "NO"}
                            </FormUi.Field>
                          </FormUi.Group>
                        </>
                      ) : null}
                    </div>
                  </Segment>
                </Formiker>
              </div>
            )}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          {isEditing && (
            <>
              {order.undo_vendor_possible ? (
                <Button
                  type="submit"
                  onClick={() => handleSubmited()}
                  disabled={
                    values.driver_name &&
                      values.driver_number &&
                      values.vehicle_type &&
                      values.vehicle_number &&
                      (values.tracking_type == 2 ? values.network_provider : true)
                      ? false
                      : true
                  }
                  size="mini"
                  className="w3-blue w3-round w3-hover-blue"
                >
                  {t("action_button.submit") || "Submit"}
                </Button>
              ) : (
                <>
                  {order.undo_vendor_possible ? (
                    <Button
                      type="submit"
                      onClick={() => handleSubmited()}
                      disabled={
                        values.driver_name &&
                          values.driver_number &&
                          values.vehicle_type &&
                          values.vehicle_number &&
                          (values.tracking_type == 2
                            ? values.network_provider
                            : true)
                          ? false
                          : true
                      }
                      size="mini"
                      className="w3-blue w3-round w3-hover-blue"
                    >
                      {t("action_button.submit") || "Submit"}
                    </Button>
                  ) : null}
                </>
              )}
            </>
          )}
          <Button
            type="button"
            onClick={() => CloseModal(true)}
            size="mini"
            // className="w3-blue w3-round green"
            color="olive"
          >
            {t("action_button.close") || "Close"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
const FormikModalVehicleDetails = withFormik({
  mapPropsToValues(props) {
    return {
      vendor: props.order.vendor_name || "",
      vendor_lr_number: props.order?.deliveries?.[0]?.lr_no || "",
      vendor_lr_date: props.order?.deliveries?.[0]?.lr_date || "",
      vendor_id: props.order.vendor_id,
      driver_id: null,
      driver_name: "",
      vehicle_id: props.order.vehicle_id || "",
      vehicle_type: "",
      driver_number: "",
      tracking_type: props?.order?.tracking_type ? props.order.tracking_type : (props.order.service_type_id === 2 ? 5 : (FEATURES.simcardTrackingTypeCust ? 2 : "")),//2
      vehicle_number: props.order.vehicle_number || "",
      vehicle_seal_no: props.order.vehicle_seal_no || "",
      ownership_type: props.order.ownership_type_id || "",
      network_provider: null,
      driver_lic: "",
      reefer_type_and_model: null,
      number_of_drivers: null,
      truck_type: null,
      data_logger_available: 0,
      data_logger_no: '',
      red_line_inside_container: 0,
      gps_available: 0,
      vehicle_registration_date: "",
      PUC_expiry_date: "",
      insurance_expiry_date: "",
      permit_expiry_date: "",
      road_tax_expiry_date: "",
      fitness_expiry_date: "",
      ewaybill_part_b: true,
      service_type: props.order.service_type_id,
    };
  },

  validationSchema: yup.object({
    vendor_id: yup.number().required("required"),
    vehicle_type: yup.number().required("required"),
    ownership_type: yup.number().nullable().optional(),
    vehicle_number: yup
      .string()
      .nullable()
      .required("required")
      .matches(AllRegex.VehicleNumber, "vehicle"),

    tracking_type: yup.mixed().required("required"),
    data_logger_available: yup.mixed().optional(),
    data_logger_no: yup.mixed().when('data_logger_available', {
      is: (data_logger_available) => {
        return data_logger_available && data_logger_available == true ? true : false
      },
      then: yup.mixed().required('is mandatory'),
      otherwise: yup.string().nullable().optional()
    }),
    /* driver_name: yup.string().when('tracking_type', {
      is: (tracking_type) => {
        console.log("Driver name ========>", tracking_type);
        return tracking_type && tracking_type != 2 ? true : false
      },
      then: yup.string().nullable().required('Driver Name is Required'),
      otherwise: yup.string().nullable().optional()
    }),
    driver_number: yup.string().when('tracking_type', {
      is: (tracking_type) => {
        console.log("Driver no ========>", tracking_type);
        return tracking_type && tracking_type != 2 ? true : false
      },
      then: yup.string().nullable().required('Driver No is Required'),
      otherwise: yup.string().nullable().optional()
    }), */
    driver_name: yup.string().nullable().optional().required("required"),
    vehicle_seal_no: yup.mixed().optional(),
    driver_number: yup
      .string()
      .nullable()
      .optional()
      .required("required")
      .matches(FEATURES.elevenNumberValidation ? AllRegex.BrazilMobileNumber : AllRegex.MobileNumber, "phone"),
    network_provider: yup.string().when("tracking_type", {
      is: (tracking_type) => {
        return tracking_type && tracking_type == 2 ? true : false;
      },
      then: yup.string().nullable().required("Network Provider is Required"),
      otherwise: yup.string().nullable().optional(),
    }),
    number_of_drivers: yup.string().nullable().optional(),
    driver_lic: yup
      .string()
      .nullable()
      .optional()
      .matches(FEATURES.brazilVehiclelicenseValidation ? AllRegex.BrazilLicenseNo : AllRegex.LicenseNumber, "license"),
    reefer_type_and_model: yup.string().nullable().optional(),
    truck_type: yup.number().nullable().optional(),
  }),

  handleSubmit(values, { setSubmitting, props, resetForm }) {
    // setSubmitting(false);
    let details = {
      poReferenceNo: props.order.purchase_order_no,
      vendorCode: props.order.vendor_code,
      vehicleNo: values.vehicle_number,
      vehicle_seal_no: values.vehicle_seal_no,
    };
    let detailshr = {
      vendorCode: props.order.vendor_code,
      vehicleNo: values.vehicle_number,
    };
    // let details = {"poReferenceNo": props.order.purchase_order_no, "vendorCode": props.order.vendor_code, "vehicleNo": values.vehicle_number,}
    let reefer_type_and_model = values.reefer_type_and_model
      ? +values.reefer_type_and_model
      : null;
    let number_of_drivers = values.number_of_drivers
      ? +values.number_of_drivers
      : null;
    let truck_type = values.truck_type ? +values.truck_type : null;

    values.PUC_expiry_date = values.PUC_expiry_date instanceof Date && !isNaN(values.PUC_expiry_date) ? moment(values.PUC_expiry_date).format(DATE_FORMATS.DATE_YYYYMMDD) : null
    values.fitness_expiry_date = values.fitness_expiry_date instanceof Date && !isNaN(values.fitness_expiry_date) ? moment(values.fitness_expiry_date).format(DATE_FORMATS.DATE_YYYYMMDD) : null
    values.insurance_expiry_date = values.insurance_expiry_date instanceof Date && !isNaN(values.insurance_expiry_date) ? moment(values.insurance_expiry_date).format(DATE_FORMATS.DATE_YYYYMMDD) : null
    values.permit_expiry_date = values.permit_expiry_date instanceof Date && !isNaN(values.permit_expiry_date) ? moment(values.permit_expiry_date).format(DATE_FORMATS.DATE_YYYYMMDD) : null
    values.road_tax_expiry_date = values.road_tax_expiry_date instanceof Date && !isNaN(values.road_tax_expiry_date) ? moment(values.road_tax_expiry_date).format(DATE_FORMATS.DATE_YYYYMMDD) : null
    values.vehicle_registration_date = values.vehicle_registration_date instanceof Date && !isNaN(values.vehicle_registration_date) ? moment(values.vehicle_registration_date).format(DATE_FORMATS.DATE_YYYYMMDD) : null
    values.driver_lic_expiry_date = values.driver_lic_expiry_date instanceof Date && !isNaN(values.driver_lic_expiry_date) ? moment(values.driver_lic_expiry_date).format(DATE_FORMATS.DATE_YYYYMMDD) : null
    
    
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.order_id}/allocate/vehicle`,
      payload: {
        ...values,
        reefer_type_and_model,
        number_of_drivers,
        truck_type,
      },
    })
      .then((res) => {
        props.reFetchOrder();
        props.CloseModal(true);
        setisEditing(false);
        window.location.reload();
        resetForm({});
        cogoToast.success(res?.data?.message);
      })
      .catch((err) => {
        if (err.response) {
          cogoToast.error(err?.response?.data?.message);
        }
      });
  },
})(ModalVehicleDetail);

const mapStateToProps = ({ auth }) => {
  return { auth };
};

export default connect(mapStateToProps, {
  successAlertDispatcher,
  errorAlertDispatcher,
})(translate("alloted_vehicle_details")(FormikModalVehicleDetails));
